export default __webpack_public_path__ + "media/images/home/nl/preview-7-4b469b6385f49daa05b261019c3c1832.jpg";